import { useTranslation } from 'next-i18next'

import { isAuthenticated } from '~/auth/slices/auth.slice'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import SettingsIcon from '~/components/Icons/svgs/SettingsIcon'
import ShieldPersonIcon from '~/components/Icons/svgs/ShieldPersonIcon'
import { Link } from '~/components/Link'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { closeMenu } from '~/redux/slices/menu'
import ROUTES from '~/shared/constants/routes.const'

import { MenuCategoryKeys } from '../constants/category.const'
import useHandleItemClick from '../hooks/useGetHandlerItemClick'
import useMenuSubscriptionState from '../hooks/useMenuSubscriptionState'

import ButtonLogout from './ButtonLogout'
import SubscriptionButton from './SubscriptionButton'

const ITEM_CLASS =
  'flex items-center gap-1 rounded-2 px-2.5 py-2 text-xs font-medium leading-3 text-white duration-300 hover:bg-purple-darker'

export default function MenuUtilityLinks({ isStacked = false }: { isStacked?: boolean }): React.ReactElement {
  const { t } = useTranslation('menu')
  const dispatch = useAppDispatch()
  const authenticated = useAppSelector(isAuthenticated)
  const handleItemClick = useHandleItemClick()
  const { showFamilyFeatures } = useMenuSubscriptionState()

  if (!authenticated) {
    return (
      <Link className={ITEM_CLASS} data-test-id="menu-login" onClick={() => dispatch(closeMenu())} to={ROUTES.LOGIN}>
        {t('login')}
      </Link>
    )
  }

  return (
    <div className={`flex ${isStacked ? 'w-full flex-col items-start' : 'items-center gap-1'}`}>
      <Link
        className={`${ITEM_CLASS} ${isStacked ? 'w-full' : ''}`}
        data-test-id="menu-settings"
        onClick={() => handleItemClick(MenuCategoryKeys.SETTINGS)}
        to={ROUTES.SETTINGS}
      >
        <SVGIcon icon={SettingsIcon} pathClassName="text-white" size={20} />
        {t('settings')}
      </Link>
      {showFamilyFeatures && (
        <Link
          className={`${ITEM_CLASS} ${isStacked ? 'w-full' : ''}`}
          data-test-id="menu-family-admin"
          onClick={() => dispatch(closeMenu())}
          to={ROUTES.FAMILY_ADMIN_PANEL}
        >
          <SVGIcon icon={ShieldPersonIcon} pathClassName="text-white" size={22} />
          {t('parentPanel')}
        </Link>
      )}
      <SubscriptionButton className={isStacked ? 'w-full' : ''} />
      {!isStacked && <span className="h-5 w-px bg-gray-ghost" />}
      <ButtonLogout className={`${ITEM_CLASS} ${isStacked ? 'w-full' : ''} text-left`} />
    </div>
  )
}
